import { render, staticRenderFns } from "./AdminPassengersDataPreview.vue?vue&type=template&id=27d5154c&scoped=true&"
import script from "./AdminPassengersDataPreview.vue?vue&type=script&lang=js&"
export * from "./AdminPassengersDataPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5154c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d5154c')) {
      api.createRecord('27d5154c', component.options)
    } else {
      api.reload('27d5154c', component.options)
    }
    module.hot.accept("./AdminPassengersDataPreview.vue?vue&type=template&id=27d5154c&scoped=true&", function () {
      api.rerender('27d5154c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Admin/AdminPassengersDataPreview.vue"
export default component.exports